import GenericVendors from '../../../shared/Vendors/Generic/GenericVendors';
import paths from '../../../../config/local/paths';
import React from 'react';
import useGetAdminsPersonalData from '../../../../Hooks/Admin/Getters/useGetAdminsPersonalData/useGetAdminsPersonalData';

export default function GenericAdminVendors() {
	const admin = useGetAdminsPersonalData();
	const groupId = admin?.data?.groups.find((group) => group.isPrimary)?.id;

	return (
		<GenericVendors
			link={`${paths.app.admin.groups.root}/${groupId}/subscription`}
			userRole="admin"
		/>
	);
}
